import { useContext, useMemo } from 'react'

import { CartFragment } from '../../../graphql/magento'
import { UsePromisify, usePromisify } from '../../../hooks/usePromisify'
import { isMagentoScopeNotGrantedError } from '../../auth/errors'
import { CartContext, CartContextValue } from '../context'
import { CartType } from '../reducers/cart-get-state'

export type UseCartContext = CartContextValue & {
  loadCart: UsePromisify<CartFragment | undefined>['load']
  loadCartType: UsePromisify<CartType | undefined>['load']
}

export const useCartContext = (): UseCartContext => {
  const context = useContext(CartContext)
  const { cart, loading, error, type } = context

  const { load: loadCart } = usePromisify({
    loading,
    error: !isMagentoScopeNotGrantedError(error) ? error : undefined,
    data: cart,
  })

  const { load: loadCartType } = usePromisify({ loading, error: undefined, data: type })

  return useMemo(() => ({ ...context, loadCart, loadCartType }), [context, loadCart, loadCartType])
}
